// Sysadmin "View as Customer" - swaps the browser's identity to a
// short-lived, read-only token scoped to the target customer (see
// POST /api/users/:id/impersonate), while stashing the admin's own
// token/userData under separate keys so exitImpersonation can restore it.
// Deliberately does NOT touch 2faEnabled/2faCompleted/2faSessionValid -
// those stay from the admin's own login, so MFAGuard doesn't re-challenge
// for an identity swap the admin already authenticated for.
import { Globals } from '../globalfunctions.js';
import { apiClient } from './apiClient';

export const isImpersonating = () => !!localStorage.getItem('adminAccessToken');

const applyUserData = (userData) => {
  Globals.Id = userData.Id;
  Globals.UserName = userData.UserName;
  Globals.UserType = userData.UserType;
  Globals.FirstName = userData.FirstName;
  Globals.LastName = userData.LastName;
  Globals.LoginTime = new Date();
};

export const startImpersonation = async (user, reason) => {
  const targetId = user.id || user.user_id;
  const result = await apiClient.post(`/api/users/${targetId}/impersonate`, { reason });

  localStorage.setItem('adminAccessToken', localStorage.getItem('accessToken'));
  localStorage.setItem('adminUserData', localStorage.getItem('userData'));
  localStorage.setItem('impersonationTargetId', String(targetId));

  const userData = {
    Id: result.user.id,
    UserName: result.user.username,
    UserType: result.user.role_type,
    FirstName: result.user.first_name,
    LastName: result.user.last_name,
  };
  localStorage.setItem('accessToken', result.token);
  localStorage.setItem('userData', JSON.stringify(userData));
  applyUserData(userData);

  return result;
};

// Restores the admin's identity first so the end-of-impersonation audit
// log call itself goes out authenticated as the admin, not the
// (about to be discarded) read-only impersonation token.
export const exitImpersonation = async () => {
  const targetId = localStorage.getItem('impersonationTargetId');
  const adminToken = localStorage.getItem('adminAccessToken');
  const adminUserDataRaw = localStorage.getItem('adminUserData');

  localStorage.removeItem('adminAccessToken');
  localStorage.removeItem('adminUserData');
  localStorage.removeItem('impersonationTargetId');

  if (!adminToken || !adminUserDataRaw) {
    // Stash is gone (cleared elsewhere) - nothing to restore to.
    return;
  }

  localStorage.setItem('accessToken', adminToken);
  localStorage.setItem('userData', adminUserDataRaw);
  applyUserData(JSON.parse(adminUserDataRaw));

  if (targetId) {
    try {
      await apiClient.post(`/api/users/${targetId}/impersonate/end`);
    } catch {
      // Best-effort - losing this one log entry shouldn't block the admin
      // from getting back to their own session.
    }
  }
};
